var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.295166,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFB800",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64426 15.249C7.66803 15.0351 7.67991 14.9281 7.71228 14.8282C7.741 14.7394 7.78157 14.655 7.83289 14.5772C7.89074 14.4895 7.96684 14.4134 8.11905 14.2612L14.9516 7.4286C15.5231 6.85713 16.4496 6.85713 17.0211 7.42861C17.5926 8.00008 17.5926 8.92662 17.0211 9.4981L10.1885 16.3307C10.0363 16.4829 9.96023 16.559 9.8725 16.6168C9.79467 16.6681 9.71026 16.7087 9.62156 16.7374C9.52158 16.7698 9.41461 16.7817 9.20069 16.8054L7.44971 17L7.64426 15.249Z",
    stroke: "#F2AE00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlock);
export default __webpack_public_path__ + "static/media/editBlock.d97c7090b8f0fdea278a17b72d6af3c5.svg";
export { ForwardRef as ReactComponent };